import React from 'react';
import { DropzoneDialog } from 'material-ui-dropzone';

const MAX_FILE_SIZE = 5000000000 //
const MAX_FILE_NUM = 100 //

const UploadForm = (props) => {
  return (
    <div>
      <DropzoneDialog
        showPreviews={true}
        maxFileSize={MAX_FILE_SIZE}
        filesLimit={MAX_FILE_NUM}
        open={props.open}
        onClose={() => {props.onClose()}}
        onSave={(files) => {props.onSave(files)}}
      />
    </div>
  )
};

export default UploadForm
